import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANG } from './config';
import ja from '../locales/ja/common.json';
import en from '../locales/en/common.json';
import zhCN from '../locales/zh-CN/common.json';
import zhTW from '../locales/zh-TW/common.json';

// 翻訳リソースは静的importする。全言語合わせても数十KBで、
// 遅延ロードによる翻訳待ちのちらつきを避けられる。
i18n.use(initReactI18next).init({
  resources: {
    ja: { common: ja },
    en: { common: en },
    'zh-CN': { common: zhCN },
    'zh-TW': { common: zhTW },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  defaultNS: 'common',
  ns: ['common'],
  interpolation: { escapeValue: false }, // Reactが自動エスケープする
  react: { useSuspense: false },
});

export default i18n;
